import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PaymentStatementOcrContainerModel } from "../../../../../../models";
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { ApiResponseModel } from '../../shared/api-response.model';
import { Observable } from 'rxjs';
import { ApiVisa } from '../../shared/api-visa.model';

// https://api.akaun.dev/core2/platform/dm/tenants/tenant-users

@Injectable({
  providedIn: 'root'
})

export class PaymentStatementOcrService extends BaseApiPublicLoginTemplateService<PaymentStatementOcrContainerModel,PaymentStatementOcrContainerModel, PaymentStatementOcrContainerModel> {

  static readonly PMT_STMT_OCR_SUB_PATH = 'ocr/payment-statements/';
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + PaymentStatementOcrService.PMT_STMT_OCR_SUB_PATH + BaseApiTemplateService.BACKOFFICE_EP;

  constructor(http: HttpClient) {
    super();
    this.httpClient = http;
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + PaymentStatementOcrService.PMT_STMT_OCR_SUB_PATH + BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + PaymentStatementOcrService.PMT_STMT_OCR_SUB_PATH + BaseApiTemplateService.BACKOFFICE_EP;
    // TODO: Change to respected ep-types once they are complete
    this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + PaymentStatementOcrService.PMT_STMT_OCR_SUB_PATH + BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path_login_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + PaymentStatementOcrService.PMT_STMT_OCR_SUB_PATH + BaseApiTemplateService.LOGIN_ENTITY_EP;
  }

  public postWithAttachment(dtoObject: FormData, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url: string;
    if (visa.api_domain_url){
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + PaymentStatementOcrService.PMT_STMT_OCR_SUB_PATH + "upload-file/" + BaseApiTemplateService.BACKOFFICE_EP;
    }
      
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}

